@if (disabled || viewMenuActions.length != 0) {
  <div class="action-container">
    <div
      ngbDropdown
      class="dropdown d-inline-flex"
      container="body"
      [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
    >
      <app-ag-action-icon-button ngbDropdownToggle iconClass="ic-more-horizontal-16"/>

      <div ngbDropdownMenu class="annual-menu dropdown-menu dropdown-menu-right">
        @for (item of viewMenuActions; track item.name) {
          <div
            ngbDropdownItem
            class="dropdown-item"
            (click)="item.action()"
          >
            <a class="menu-action-button">
              <i [class]="item.iconClass"></i>
              <span>{{ item.name }}</span>
            </a>
          </div>
        }
      </div>
    </div>
  </div>
}
